import { TrendingUpDown } from '@tamagui/lucide-icons';
import { AssetList } from '@unistocks/features/dashboard/components/dashboard-data/asset-list/asset-list';
import { AssetListLayout } from '@unistocks/features/dashboard/components/dashboard-data/asset-list/layout';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/asset-list/query-filter';
import {
  AssetListSettingsContentStep,
  AssetListSettingsLayoutStep,
  assetListSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/asset-list/settings';
import {
  DashboardItemDescriptor,
  DashboardItemNormalizeSettings
} from '@unistocks/features/dashboard/dashboard-item-descriptor';
import { ensurePortfolioFilter } from '@unistocks/features/dashboard/utils';
import { AssetListType, DateConstant } from '@unistocks/proxy/axios-client';
import { hasFlag } from '@unistocks/shared/utils/util';

const normalizeAssetListSettings: DashboardItemNormalizeSettings = settings => ({
  ...ensurePortfolioFilter(settings),
  [AssetListLayout[AssetListLayout.PercentageChange]]: hasFlag(
    settings.layout,
    AssetListLayout.PercentageChange
  ),
  [AssetListLayout[AssetListLayout.NominalChange]]: hasFlag(
    settings.layout,
    AssetListLayout.NominalChange
  ),
  [AssetListLayout[AssetListLayout.CurrentPrice]]: hasFlag(
    settings.layout,
    AssetListLayout.CurrentPrice
  )
});

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: AssetList,
  settingsSteps: [AssetListSettingsContentStep, AssetListSettingsLayoutStep],
  schemaFactory: assetListSchemaFactory,
  normalizeSettings: normalizeAssetListSettings,
  defaults: setValue => {
    setValue('layout', AssetListLayout.PercentageChange);
    setValue(AssetListLayout[AssetListLayout.PercentageChange] as any, true);
    setValue('listType', AssetListType.Both);
    setValue('period', DateConstant.ThisYear);
    setValue('sections', []);
    setValue('assetTypes', []);
  },
  queryFilter: queryFilter,
  icon: TrendingUpDown
};
